var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDrop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 18.7501C4.96048 18.7478 3.24491 18.0359 1.97953 16.7705C0.714148 15.5052 0.00226243 13.7896 0 12.0001C0.0403467 10.6843 0.426858 9.40234 1.12057 8.28352L6.1146 0.327599C6.18673 0.226296 6.28203 0.143708 6.39256 0.0867205C6.50309 0.0297334 6.62564 0 6.75 0C6.87436 0 6.99691 0.0297334 7.10744 0.0867205C7.21797 0.143708 7.31327 0.226296 7.3854 0.327599L12.3571 8.2449C13.0626 9.37391 13.4569 10.6695 13.5 12.0001C13.4977 13.7896 12.7859 15.5052 11.5205 16.7705C10.2551 18.0359 8.53952 18.7478 6.75 18.7501ZM6.75 2.1363L2.41372 9.04222C1.85492 9.93093 1.5398 10.951 1.5 12.0001C1.5 13.3925 2.05312 14.7278 3.03769 15.7124C4.02226 16.697 5.35761 17.2501 6.75 17.2501C8.14239 17.2501 9.47774 16.697 10.4623 15.7124C11.4469 14.7278 12 13.3925 12 12.0001C11.9573 10.9363 11.6344 9.90259 11.064 9.0036L6.75 2.1363Z",
    fill: "currentcolor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/drop.3301ce09.svg";
export { ForwardRef as ReactComponent };